import { useState, useEffect, useCallback } from "react";
import { getDriverDetails } from "../../../hooks/use-driver";

export function useDriverDetails(driverId, partnerId) {
  const [driverDetails, setDriverDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDriverDetails = useCallback(async () => {
    if (!driverId) return;
    try {
      setIsLoading(true);
      setError(null);
      const result = await getDriverDetails(driverId, partnerId);
      setDriverDetails(result);
    } catch (err) {
      console.log("driver details get api error: ", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [driverId, partnerId]);

  useEffect(() => {
    fetchDriverDetails();
  }, [fetchDriverDetails]);

  return { driverDetails, isLoading, error, refetch: fetchDriverDetails };
}
